import type { OnInit } from '@angular/core';
import { Component, inject, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { LinkComponent } from 'components/atoms/link/link.component';
import { ThemeDirective } from 'src/directives/theme/theme.directive';
import type { TAvailableFooterTypes } from 'src/pages/layouts/services/layout.service';
import { LayoutService } from 'src/pages/layouts/services/layout.service';
import { LocaleService } from 'src/services/locale/locale.service';
import { PageLocalizationService } from 'src/services/page-localization/page-localization.service';
import { addSlashToEndOfUrl } from 'src/shared/helpers/add-slash-to-end-of-url/add-slash-to-end-of-url';
import type { TFullColorScheme } from 'src/shared/types/color-schemes-and-themes';

import { LayoutComponent } from '../../layouts/layout.component';

@Component({
    selector: 'tp-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
    imports: [LinkComponent, TranslatePipe, ThemeDirective],
})
export class ErrorComponent implements OnInit {
    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly localeService = inject(LocaleService);
    private readonly layoutComponent = inject(LayoutComponent);
    private readonly pageLocalizationService = inject(PageLocalizationService);
    private readonly layoutService = inject(LayoutService);

    @Input() public error: Error;
    @Input() public colorScheme: TFullColorScheme = 'white';
    public pathToLocaleRootHomePage = '/';
    public isPreview: boolean;

    public ngOnInit(): void {
        this.isPreview = this.activatedRoute.snapshot.data.isPreview;

        if (this.isPreview !== true) {
            this.getDefaultMenu();
        }

        this.pathToLocaleRootHomePage = addSlashToEndOfUrl(this.localeService.getPathToLocaleSlug());
        this.pageLocalizationService.setPageLocalization();
    }

    private renderLayout() {
        const isRtlLocale = this.localeService.getCurrentLocaleDirection() === 'rtl';
        const footerType = this.determineErrorFooterType(isRtlLocale);

        this.layoutComponent.headerViewService.setTheme(this.colorScheme);
        this.layoutService.configureFooter(footerType, this.colorScheme);
    }

    private determineErrorFooterType(isRtlLocale: boolean): TAvailableFooterTypes {
        return isRtlLocale ? 'light' : 'full';
    }

    private getDefaultMenu() {
        this.layoutService.fetchDefaultLayoutOnError().subscribe(() => {
            if (this.layoutService.shouldRenderHeader()) {
                this.renderLayout();
            }
        });
    }
}
